export default __webpack_public_path__ + "static/media/nextArrow.92893090.svg";